import axios from 'axios';

import { addNotification, removeAllNotifications, NotificationImportance } from 'store/common/commonActions';
import { fetchQualifications } from '../qualification/qualificationActions';


/**
 * Liste des actions
 */
export const Actions = {
    FETCH_LOGIN_REQUEST: 'FETCH_LOGIN_REQUEST',
    FETCH_LOGIN_SUCCESS: 'FETCH_LOGIN_SUCCESS',
    FETCH_LOGIN_FAILURE: 'FETCH_LOGIN_FAILURE',

    LOGOUT: 'LOGOUT'
};

/**
 * FETCH_LOGIN
 * ActionCreators pour le login de l'utilisateur
 */
const fetchLoginRequest = () => ({ type: Actions.FETCH_LOGIN_REQUEST });
const fetchLoginSuccess = () => ({ type: Actions.FETCH_LOGIN_SUCCESS });
const fetchLoginFailure = error => ({ type: Actions.FETCH_LOGIN_FAILURE, error });

export const fetchLogin = (username, password, domaine) => async (dispatch, getState) => {
    
    dispatch(fetchLoginRequest());

    try {
        let response = await axios.post(`/api/utilisateurs/login`, { username: username, password: password, domaine: domaine });

        let utilisateur = JSON.stringify(response.data);

        // Sauvegarde de l'utilisateur dans le local storage
        localStorage.setItem('utilisateur', utilisateur);

        if (getState().common.notifications.length > 0)
            dispatch(removeAllNotifications());

        dispatch(fetchLoginSuccess());
        dispatch(fetchQualifications(true));
        return response.data;
    } catch (error) {
        console.error('fetchLogin : ', error);
        localStorage.removeItem('utilisateur');
        dispatch(fetchLoginFailure(error));

        // Récupération du message d'erreur depuis l'API, sinon message par défaut
        const errorMessage = error.response?.data?.message || `Nom d'utilisateur ou mot de passe incorrect.`;
        dispatch(addNotification(errorMessage, NotificationImportance.error));
        return false;
    }
};

/**
 * LOGOUT
 * ActionCreator pour la déconnexion de l'utilisateur
 */
export const logout = () => dispatch => {
    localStorage.removeItem('utilisateur');
    dispatch({ type: Actions.LOGOUT });
    return;
};